import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'
import s from './ProductScreenshots.scss'
import cn from 'classnames'
import { Row, Col } from 'components/Layout'
import sLay from 'styles/modules/layout.scss'
import Sms from 'components/Icons/Sms'
import PhoneNumbers from 'components/Icons/PhoneNumbers'
import CallHandling from 'components/Icons/CallHandling'
import CallRecording from 'components/Icons/CallRecording'
import CallAnalytics from 'components/Icons/CallAnalytics'
import FlowBuilder from 'components/Icons/FlowBuilder'

import ImgCallAnalytics from 'static/images/screenshots/CallAnalytics.png'
import ImgCallRecordings from 'static/images/screenshots/CallRecordings.png'
import ImgFlowBuilder from 'static/images/screenshots/FlowBuilder.png'
import ImgPhoneNumbers from 'static/images/screenshots/PhoneNumbers.png'
import ImgPhoneSystem from 'static/images/screenshots/PhoneSystem.png'
import ImgSMS from 'static/images/screenshots/SMS.png'

const options = [
  {
    icon: PhoneNumbers,
    name: 'Phone Numbers',
    screenshot: ImgPhoneNumbers,
  },
  {
    icon: Sms,
    name: 'SMS Messaging',
    screenshot: ImgSMS,
  },
  {
    icon: CallHandling,
    name: 'Phone Systems',
    screenshot: ImgPhoneSystem,
  },
  {
    icon: CallAnalytics,
    name: 'Call Analaytics',
    screenshot: ImgCallAnalytics,
  },
  {
    icon: CallRecording,
    name: 'Call Recording',
    screenshot: ImgCallRecordings,
  },
  {
    icon: FlowBuilder,
    name: 'Call Flows',
    screenshot: ImgFlowBuilder,
  },
]

export default class ProductScreenshot extends React.Component {
  state = {
    active: 3,
  }
  render() {
    const props = this.props
    return (
      <Section
        color={props.color}
        fullHeight={props.fullHeight}
        paddingTop={props.paddingTop}
        paddingBottom={props.paddingBottom}
        sectionWidth={props.sectionWidth}
      >
        <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
          <Col className={sLay['flex-gt-xs']}>
            <Markdown text={props.text} color={props.color} />
            <br />
            <br />
            <Row className={cn(sLay['layout-row'], sLay['layout-wrap'], s.options)}>
              {options.map((option, idx) => (
                <Col
                  key={idx}
                  className={cn(sLay['flex-33'], { [s.active]: this.state.active === idx })}
                  onClick={() => this.setState({ active: idx })}
                >
                  <option.icon />
                  <div>{option.name}</div>
                </Col>
              ))}
            </Row>
          </Col>
          <Col className={sLay['flex-gt-xs']} style={{ position: 'relative' }}>
            <div className={s.frame}>
              <div className={s.frameChrome}>
                <div className={cn(s.dot, s.red)} />
                <div className={cn(s.dot, s.orange)} />
                <div className={cn(s.dot, s.green)} />
              </div>
              <div className={s.inner}>
                <img src={options[this.state.active].screenshot} />
              </div>
            </div>
          </Col>
        </Row>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ProductScreenshots/ProductScreenshots.jsx